import { parse, format, eachDayOfInterval } from 'date-fns';

const checkCampaignLengthValidity = (
  startDate: string,
  endDate: string,
  checkedLengthPerMonth = 8
): boolean => {
  const start = parse(startDate, 'dd-MM-yyyy', new Date());
  const end = parse(endDate, 'dd-MM-yyyy', new Date());

  const days = eachDayOfInterval({ start, end });

  const monthMap: Record<string, number> = days.reduce((acc, day) => {
    const key = format(day, 'yyyy-MM');
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  return Object.values(monthMap).every(
    (count) => count >= checkedLengthPerMonth
  );
};

export default checkCampaignLengthValidity;
